/** @description 自定义节点 开始 */

import { Handle, Position } from 'react-flow-renderer';
import { DataType, TableItemData } from '@/components/index';
import { Item, nodeStyle, switchWrapperStyle, getChildNodeLength } from '@/components/node-default';
import { useDispatch, useSelector } from 'umi';
import { Switch } from 'antd';
import React, { useMemo } from 'react';
import Container from './container';
import { DropResult } from './box';
import { SWITCH_EVENT } from './node-form';

function MyNode({ data, selected }: { data: TableItemData, selected: boolean }) {
  const dispatch = useDispatch();
  const nodeHiddenMap = useSelector((state: any) => state.open.nodeHiddenMap);
  const edges = useSelector((state: any) => state.open.edges);
  const selectedNode = useSelector((state: any) => state.open.selectedNode);
  const selectedEdge = useSelector((state: any) => state.open.selectedEdge);
  
  const childCount = useMemo(() => {
    return getChildNodeLength(data.id, edges)
  }, [edges]);

  const checked = () => {
    let b_arr = nodeHiddenMap[data.id] ?? [false];
    return !b_arr[b_arr.length - 1];
  }
  const handleShowNodeChange = (value: boolean) => {
    if (!dispatch) return;
    dispatch({
      type: 'open/handleNodeHidden',
      payload: {
        hidden: !value,
        nodeId: data.id,
      }
    })
  }

  const onDrop = (item: DropResult) => {
    dispatch({
      type: 'open/handleCopyItem',
      payload: { nodeId: data.id, ...item }
    })
  }

  let borderColor = '#777';
  if (selected) borderColor = '#E0144C';
  let opacity = 1;
  if ((selectedNode && selectedNode !== data.id) || selectedEdge) opacity = 0.3;

  return <Container id={data.id} onDrop={onDrop}>
    <div style={{ ...nodeStyle, borderColor, opacity }}>
      <div style={{ fontSize: 12, fontWeight: 600 }}>{data.label}</div>
      {Item(data.isOnEnter, data.onEnter, SWITCH_EVENT.初入, data.label, data.id)}
      {Item(data.isOnIdle, data.onIdle, SWITCH_EVENT.挽留, data.label, data.id)}
      {Item(data.isOnReceive, data.onReceive, SWITCH_EVENT.匹配, data.label, data.id)}
      <div style={switchWrapperStyle}><Switch checkedChildren={`展开:${childCount}`} unCheckedChildren={`收起:${childCount}`} checked={checked()} onChange={handleShowNodeChange} /></div>
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: '#555' }}
      />
    </div>
  </Container>;
}

export default React.memo(MyNode);
